import React, { useMemo } from 'react';
import { KeyMetricData } from 'src/types';
import { KeyMetricCard } from 'src/components/molecules/KeyMetricCard';
import { calculateTrendFromTimeSeries } from 'src/utils/calculateTrendFromTimeSeries';
import { useLTDataContext } from '../../../contexts/LTDataContext';
// eslint-disable-next-line no-restricted-imports
import { Icon as ChakraIcon } from '@chakra-ui/react';
import { CircleDollarSign } from 'lucide-react';

export const Investment: React.FC = () => {
  const { investments, isError, isLoading } = useLTDataContext();

  const keyMetricData: KeyMetricData = useMemo(() => {
    let sum = 0;
    const data = investments.monthly.map((x) => {
      const value = x.totalInvestment;
      sum += value;
      return {
        utcEpoch: x.utcEpoch,
        value,
      };
    });

    return {
      name: 'Investment',
      data,
      isEuro: true,
      summaryValue: sum,
      isError,
      isLoading,
    };
  }, [investments, isError, isLoading]);

  const { trend, trendValue } = useMemo(() => {
    return calculateTrendFromTimeSeries(keyMetricData?.data ?? []);
  }, [keyMetricData]);

  return (
    <KeyMetricCard
      isEuro={keyMetricData.isEuro}
      title="Investment"
      trend={trend}
      trendValue={trendValue}
      value={keyMetricData.summaryValue}
      isLoading={isLoading}
      isError={isError}
      icon={<ChakraIcon as={CircleDollarSign} boxSize={5} color="gray.500" />}
    />
  );
};
